import { render, staticRenderFns } from "./OrderFinish.vue?vue&type=template&id=2b65f149&scoped=true&"
import script from "./OrderFinish.vue?vue&type=script&lang=js&"
export * from "./OrderFinish.vue?vue&type=script&lang=js&"
import style0 from "./OrderFinish.vue?vue&type=style&index=0&id=2b65f149&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b65f149",
  null
  
)

export default component.exports